exports.pursFromTs = require("src/client/components/InteropExample/PursFromTs/PursFromTs.tsx").PursFromTsExample;
